var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDSignalHeatingPumpOnOff2 = function SvgDSignalHeatingPumpOnOff2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 462,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666,452c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M666,451c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M666,469.57c-4.17,0-7.57-3.43-7.57-7.64,0-2.43,1.11-4.66,3.03-6.12l.6.8c-1.68,1.27-2.64,3.21-2.64,5.32,0,3.66,2.95,6.64,6.57,6.64s6.57-2.98,6.57-6.64c0-2.11-.96-4.05-2.63-5.31l.61-.8c1.92,1.46,3.02,3.69,3.02,6.11,0,4.21-3.4,7.64-7.57,7.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.5,
    y: 453.36,
    width: 1,
    height: 7.14
  }))))));
};
export default SvgDSignalHeatingPumpOnOff2;